<div class="detail" [loading]="loading">
  <div *ngIf="!loading">
    <div style="display:flex">
      <div class="line-height-l" style="min-width: 190px;">
        <a uiSref="symap.project.projectSettings.lessees" class="button mb-10"><i class="fa fa-chevron-left mr-5"></i> Seznam pachtýřů</a>
      </div>
      <div class="actions">
        <a (click)="onEdit()" class="button"><i class="fa fa-pencil"></i>Editace pachtýře</a>
      </div>
    </div>

    <h1>Pachtýř</h1>

    <fieldset class="bordered">
      <legend>Typ osoby</legend>
      <div class="column-100">
        <div class="info">
          {{ lessee.subjectType | projectSubjectTypeName }}
        </div>
      </div>
    </fieldset>

    <fieldset *ngIf="lessee.subjectType.indexOf('OPO') === 0" class="bordered">
      <legend>Základní údaje</legend>
      <div class="column-100">
        <label>Název</label>
        {{ lessee.companyName }}
      </div>

      <div class="column-100">
        <label>Závod / správa</label>
        <div class="info">{{ lessee.branchName }}</div>
      </div>

      <div class="column-50">
        <label>IČO</label>
        <div class="info">{{ lessee.identificationNumber }}</div>
      </div>

      <div class="column-50">
        <label>DIČ</label>
        <div class="info">{{ lessee.vatId }}</div>
      </div>
    </fieldset>

    <fieldset *ngIf="lessee.subjectType === 'OFO'" class="bordered">
      <legend>Základní údaje</legend>
      <div class="column-50">
        <label>Titul před jménem</label>
        <div class="info">{{ lessee.titleBefore }}</div>

        <label>Křestní jméno</label>
        <div class="info">{{ lessee.firstName }}</div>

        <label>Příjmení</label>
        <div class="info">{{ lessee.surname }}</div>

        <label>Titul za jménem</label>
        <div class="info">{{ lessee.degreeAfter }}</div>
      </div>
      <div class="column-50">
        <label>R.Č.</label>
        <div class="info">{{ lessee.personalIdentificationNumber }}</div>
      </div>
    </fieldset>

    <fieldset *ngIf="lessee.subjectType.indexOf('OPO') === 0" class="bordered">
      <legend>Zápis obchodního rejtříku</legend>

      <div class="column-100">
        <label>Rejstříkový soud</label>
        <div class="info">{{ lessee.businessRegisterName }}</div>
      </div>
      <div class="column-50">
        <label>Oddíl</label>
        <div class="info">{{ lessee.businessRegisterSection }}</div>
      </div>
      <div class="column-50">
        <label>Vložka</label>
        <div class="info">{{ lessee.businessRegisterEntry }}</div>
      </div>
    </fieldset>

    <fieldset class="bordered">
      <legend>Adresa</legend>
      <div class="column-100">
        <label>Ulice</label>
        <div class="info">{{ lessee.street }}</div>
      </div>
      <div class="column-50">
        <label>Číslo popisné</label>
        <div class="info">{{ lessee.houseNumber }}</div>
      </div>
      <div class="column-50">
        <label>Číslo orientační</label>
        <div class="info">{{ lessee.streetNumber }}</div>
      </div>
      <div class="column-50">
        <label>Obec</label>
        <div class="info">{{ lessee.municipality }}</div>
      </div>
      <div class="column-50">
        <label>PSČ</label>
        <div class="info">{{ lessee.postCode | postCode }}</div>
      </div>
      <div class="column-50">
        <label>Část obce</label>
        <div class="info">{{ lessee.neighbourhood }}</div>
      </div>
      <div class="column-50">
        <label>Městská část</label>
        <div class="info">{{ lessee.quarter }}</div>
      </div>
    </fieldset>

    <fieldset class="bordered">
      <legend>Kontakt</legend>
      <div class="column-50">
        <label>E-mail</label>
        <div class="info">{{ lessee.email }}</div>
      </div>

      <div class="column-50">
        <label>Telefon</label>
        <div class="info">{{ lessee.phoneNumber }}</div>
      </div>

      <div class="column-50">
        <label>Číslo účtu</label>
        <div class="info">{{ lessee.accountNumber }}</div>
      </div>

      <div class="column-50">
        <label>Kód banky</label>
        <div class="info">{{ lessee.bankCode }}</div>
      </div>
    </fieldset>

    <fieldset *ngIf="lessee.subjectType.indexOf('OPO') === 0" class="bordered">
      <legend>Jednající osoby</legend>
      <div class="preview-list" *ngIf="lessee.actingPersons.length">
        <div class="preview-list-item column-100" *ngFor="let acting of lessee.actingPersons">
          <label>Křestní jméno</label>
          <div class="info">{{ acting.firstName }}</div>

          <label>Příjmení</label>
          <div class="info">{{ acting.surname }}</div>

          <label>Titul před jménem</label>
          <div class="info">{{ acting.titleBefore }}</div>

          <label>Titul za jménem</label>
          <div class="info">{{ acting.degreeAfter }}</div>

          <label>Funkce</label>
          <div class="info">{{ acting.function }}</div>
        </div>
      </div>
      <div class="empty-info" *ngIf="!lessee.actingPersons.length">
        Žádné jednající osoby
      </div>
    </fieldset>
  </div>
</div>
